import { ViewModel, View, ObservableArray } from "binder"
import { NotificationsWindowView } from "./notificationsWindow-view"
import { WindowViewModel } from "../../windowContainer/windowContainer-viewModel";
import moment from "moment";
import { CallServerView } from "src/formBuilder/datamodel/dataModelBuilder/methodManipulation/methodBody/executablePart/callServer/callServer-view";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { IPopup } from "../../windowContainer/IPopup";
import { translate } from "src/common/utilities";

export class NotificationsWindowViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("notificationsWindow-viewModel.userMessages", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.notifications = ObservableArray.create<singleNotification>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh()

    }
    GetDefaultView(): View<ViewModel> {
        return new NotificationsWindowView();
    }
    public getTypeId(): string {
        return "VM-EA5BFEEA-62C5-47E6-9893-12899B6F2B4D"
    }

    public set notifications(v: ObservableArray<singleNotification>) { this._notifications = v; } public get notifications(): ObservableArray<singleNotification> { return this._notifications; } private _notifications: ObservableArray<singleNotification>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async refresh() {
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/UserNotifications/ListReceivedNotifications', {
                FurtherQueryInfo: filteringInformation
            });
            this.notifications.update(...result.Notifications.map((x, i) => {
                let r = new singleNotification(this);
                r.index = (result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize + i + 1;
                r.id = x.Id;
                r.title = x.Title;
                r.body = x.Body;
                r.alertType = x.AlertType;
                r.creationTime = moment.utc(x.CreationTime);
                r.senderUsername = x.SenderUsername;
                r.isShown = x.IsShown;
                r.showTime = x.ShowTime ? moment.utc(x.ShowTime) : null;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return null;
        } finally {
            this.isLoading = false;
        }
    }
}

export class singleNotification extends ViewModel implements IPopup {
    public getTypeId(): string { return 'notification'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: NotificationsWindowViewModel) {
        super(parent);
        this._parent = parent;
    }
    closePopup(result?: any) {
    }
    private _parent;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
    public set body(v: string) { this._body = v; } public get body(): string { return this._body; } private _body: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set alertType(v: number) { this._alertType = v; } public get alertType(): number { return this._alertType; } private _alertType: number;
    public set senderUsername(v: string) { this._senderUsername = v; } public get senderUsername(): string { return this._senderUsername; } private _senderUsername: string;
    public set showTime(v: moment.Moment) { this._showTime = v; } public get showTime(): moment.Moment { return this._showTime; } private _showTime: moment.Moment;
    public set isShown(v: boolean) { this._isShown = v; } public get isShown(): boolean { return this._isShown; } private _isShown: boolean;

    showDetail() {
        if (this.isShown == false) {
            this.setShow();
        }
        this.requestShowingPopup(this)
    }

    async setShow() {
        let result = await ServerConnection.callServer('/Complex/UserNotifications/SetNotificationShown', {
            Id: this.id
        });
        if (result.IsSuccessful) {
            this._parent.refresh()
        }
    }

    back() {
        this.closePopup()
    }
}
